import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { Skeleton } from '@/components/ui/skeleton';
import {
  usePreferenciasNotificacao,
  useTogglePreferencia,
  FUNCIONALIDADES,
  SEVERIDADES,
} from '@/hooks/usePreferenciasNotificacao';

const FUNC_LABELS: Record<string, string> = {
  usuarios: 'Gestão de Usuários',
  professores: 'Gestão de Professores',
  impressao: 'Solicitação de Impressão',
  laboratorios: 'Lumina Lab',
  ativos: 'Equipamentos',
};

const SEV_LABELS: Record<string, string> = {
  info: 'Informativa',
  warning: 'Alerta',
  error: 'Crítica',
};

export const NotificacoesConfig = () => {
  const { data: preferencias, isLoading } = usePreferenciasNotificacao();
  const toggleMutation = useTogglePreferencia();

  const isAtivo = (func: string, sev: string): boolean => {
    if (!preferencias) return true; // opt-out: padrão é ativo
    const pref = preferencias.find(
      (p) => p.funcionalidade === func && p.severidade === sev
    );
    return pref ? pref.ativo : true;
  };

  const handleToggle = (func: string, sev: string, checked: boolean) => {
    toggleMutation.mutate({ funcionalidade: func, severidade: sev, ativo: checked });
  };

  if (isLoading) {
    return (
      <div className="space-y-4">
        {[1, 2, 3].map((i) => (
          <Skeleton key={i} className="h-12 w-full" />
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-sm font-semibold text-foreground mb-1">Preferências de Notificação</h3>
        <p className="text-xs text-muted-foreground mb-4">
          Selecione os tipos de notificação que deseja receber.
        </p>
      </div>

      <div className="rounded-md border">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b bg-muted/50">
              <th className="text-left p-3 font-medium">Funcionalidade</th>
              {SEVERIDADES.map((sev) => (
                <th key={sev} className="text-center p-3 font-medium">
                  {SEV_LABELS[sev]}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {FUNCIONALIDADES.map((func) => (
              <tr key={func} className="border-b last:border-0">
                <td className="p-3 font-medium">{FUNC_LABELS[func]}</td>
                {SEVERIDADES.map((sev) => (
                  <td key={sev} className="text-center p-3">
                    <Checkbox
                      checked={isAtivo(func, sev)}
                      onCheckedChange={(checked) =>
                        handleToggle(func, sev, !!checked)
                      }
                      disabled={toggleMutation.isPending}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
